import React from 'react';

import { Box, Chip, Typography } from '@mui/material';

import { ConfidenceScoreTier } from '../types';

interface Props {
  confidence?: string;
}

export function getConfidenceColour(confidence: string | undefined): 'success' | 'warning' | 'error' | 'default' {
  switch (confidence) {
    case ConfidenceScoreTier.HIGH:
      return 'success';
    case ConfidenceScoreTier.MEDIUM:
      return 'warning';
    case ConfidenceScoreTier.LOW:
      return 'error';
    default:
      return 'default';
  }
}
export default function ConfidenceScoreFormatter({ confidence }: Props) {
  const colour = getConfidenceColour(confidence);
  return (
    <Box>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Confidence Score:
        </Typography>{' '}
        <Chip component="span" label={confidence.toUpperCase()} size="small" color={colour} />
      </Typography>
    </Box>
  );
}
